import type { FC } from 'react';
import { Typography } from '@interstate/components/Typography';
import { Spinner } from '@interstate/components/Spinner';
import { LoadingSectionParent } from '@makemydeal/dr-shared-components';
import { LoadingContainer } from './search.styles';

export interface SearchLoadingProps {
    testId: string;
}

const SearchLoading: FC<SearchLoadingProps> = ({ testId }) => (
    <LoadingSectionParent data-testid={testId}>
        <LoadingContainer>
            <Spinner size={60} />
            <Typography variant="body-md">Loading Results</Typography>
        </LoadingContainer>
    </LoadingSectionParent>
);

export default SearchLoading;
